export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 512 512" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="spg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#ff8a3d" />
        <stop offset="1" stopColor="#ff4d4d" />
      </linearGradient>
    </defs>
    <rect width="512" height="512" rx="112" fill="#16181f" />
    <g fill="url(#spg)">
      <rect x="96" y="176" width="52" height="160" rx="14" />
      <rect x="364" y="176" width="52" height="160" rx="14" />
      <rect x="52" y="212" width="40" height="88" rx="12" />
      <rect x="420" y="212" width="40" height="88" rx="12" />
      <rect x="148" y="236" width="216" height="40" rx="10" />
    </g>
  </svg>
);

export const Logo = ({ testId = "navbar-logo" }) => (
  <a href="/#top" data-testid={testId} className="group flex items-center gap-2.5">
    <LogoMark className="h-8 w-8 transition-transform duration-500 group-hover:rotate-[-12deg]" />
    <span className="font-display text-2xl font-extrabold uppercase tracking-wide">Spotter</span>
  </a>
);
